import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgFavourite = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.3601 2.72979C11.5128 1.40378 9.23172 2.02258 8.00019 3.54013C6.76867 2.02258 4.48754 1.39641 2.64025 2.72979C1.66063 3.43699 1.04487 4.6304 1.00288 5.89011C0.90492 8.7484 3.312 11.0395 6.98558 14.5534L7.05555 14.6197C7.58735 15.128 8.40604 15.128 8.93783 14.6123L9.0148 14.5387C12.6884 11.0321 15.0885 8.74104 14.9975 5.88275C14.9555 4.6304 14.3398 3.43699 13.3601 2.72979ZM8.07017 13.4557L8.00019 13.5294L7.93022 13.4557C4.5995 10.2807 2.40234 8.18117 2.40234 6.05218C2.40234 4.57884 3.45194 3.47383 4.8514 3.47383C5.92899 3.47383 6.97858 4.20313 7.34944 5.21238H8.65794C9.0218 4.20313 10.0714 3.47383 11.149 3.47383C12.5484 3.47383 13.598 4.57884 13.598 6.05218C13.598 8.18117 11.4009 10.2807 8.07017 13.4557Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgFavourite)
const IconSvgFavourite = createIcon(ForwardRef, 'SvgFavourite')
export default IconSvgFavourite
